import type { FC } from 'react';
import React from 'react';
import type { ButtonV2Props } from '@withjoy/joykit';
import { ButtonV2, TextV2 } from '@withjoy/joykit';
import { TooltipV2Wrapper } from '@shared/components/TooltipV2Wrapper';
import { pxToRem } from '@withjoy/joykit/theme';
import { dottedUnderlineStyles } from './DottedButton.styles';

type DottedButtonProps = Readonly<{
  onClick?: ButtonV2Props['onClick'];
  label: string;
  tooltipText?: string;
  buttonStyles?: ButtonV2Props;
  isDisabled?: boolean;
  href?: string;
  testId?: string;
}>;

export const DottedButton: FC<DottedButtonProps> = props => {
  const { onClick, label, tooltipText, buttonStyles, isDisabled, href, testId } = props;
  return (
    <TooltipV2Wrapper
      content={<TextV2 typographyVariant="label2">{tooltipText}</TextV2>}
      disabled={!tooltipText}
    >
      <ButtonV2
        data-testid={testId}
        variant="link"
        size="sm"
        shape="rounded"
        intent="neutral"
        width="fit-content"
        color="newUIBrandPrimary"
        onClick={onClick}
        cursor="pointer"
        disabled={isDisabled}
        _hover={{
          textDecoration: 'none',
          color: 'buttonPrimaryHover',
        }}
        {...(href ? { as: 'a' as const, href } : {})}
        {...buttonStyles}
      >
        <TextV2
          typographyVariant="label6"
          fontSize={pxToRem(14)}
          css={dottedUnderlineStyles}
        >
          {label}
        </TextV2>
      </ButtonV2>
    </TooltipV2Wrapper>
  );
};

DottedButton.displayName = 'DottedButton';
